import { render, staticRenderFns } from "./IntroduceSignature.vue?vue&type=template&id=6b48e3b6&"
import script from "./IntroduceSignature.vue?vue&type=script&lang=js&"
export * from "./IntroduceSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports